import { createSelector } from 'reselect'

export const getServiceProviderPhotos = createSelector(
  state => state && state.user && state.user.profile && Array.isArray(state.user.profile.photos)
    ? state.user.profile.photos : [],
  photos => photos
)
